module.exports = __webpack_public_path__ + "img/urgent_light.7fd82810.svg";